import { Alert, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useFieldValue } from '../../hooks/useFormValues';
import type { FieldComponentProps } from '../form-engine/types';

const DAYS_IN_TMY = 365;

// Number of TMY calendar days (MM-DD, leap day excluded) with an uploaded value.
const coveredCalendarDays = (pattern: { dates: string[]; values: (number | null)[] }) =>
  new Set(
    pattern.dates
      .filter((_, i) => pattern.values[i] !== null)
      .map((date) => date.slice(5, 10))
      .filter((day) => day !== '02-29'),
  ).size;

const RainBiasCorrectionWarning = ({ field }: FieldComponentProps) => {
  const biasCorrection = useFieldValue('rain_operational.bias_correction');
  const pattern = useFieldValue('rain_operational.rain_pattern');

  // An unset toggle ('') defaults to enabled, like the backend.
  const enabled = biasCorrection === '' || Boolean(biasCorrection);
  if (!enabled || !pattern?.dates || coveredCalendarDays(pattern) >= DAYS_IN_TMY) {
    return null;
  }

  return (
    <Grid size={field.size || 12}>
      <Alert severity="warning">
        <Typography variant="body2">
          Bias correction is only applied to the months (or days) covered by your uploaded rainfall data. For all remaining period, the
          original TMY data are retained unchanged.
        </Typography>
      </Alert>
    </Grid>
  );
};

export default RainBiasCorrectionWarning;
